(() => {
const catalogue=document.querySelector('[data-review-catalogue]');
if(!catalogue)return;
const buttons=[...catalogue.querySelectorAll('[data-review-style]')];
const select=catalogue.querySelector('[data-review-pattern]');
const cards=[...catalogue.querySelectorAll('[data-review-grid] .product-card')];
const params=new URL(location.href).searchParams;
let style=buttons.some(button=>button.dataset.reviewStyle===params.get('style'))?params.get('style'):'all';
if([...select.options].some(option=>option.value===params.get('pattern')))select.value=params.get('pattern');
const apply=(updateUrl=true)=>{
let count=0;
for(const card of cards){card.hidden=(style!=='all'&&card.dataset.category!==style)||(select.value!=='all'&&card.dataset.pattern!==select.value);if(!card.hidden)count++;}
for(const button of buttons){const active=button.dataset.reviewStyle===style;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));}
catalogue.querySelector('[data-review-count]').textContent=String(count);
const noun=catalogue.querySelector('[data-review-noun]');noun.textContent=count===1?noun.dataset.singular:noun.dataset.plural;
catalogue.querySelector('[data-review-empty]').hidden=count>0;
catalogue.querySelector('[data-review-reset]').hidden=style==='all'&&select.value==='all';
if(updateUrl){const url=new URL(location.href);for(const [key,value] of [['style',style],['pattern',select.value]]){if(value==='all')url.searchParams.delete(key);else url.searchParams.set(key,value);}history.replaceState({},'',url);}
};
for(const button of buttons)button.addEventListener('click',()=>{style=button.dataset.reviewStyle;apply();});
select.addEventListener('change',()=>apply());
catalogue.querySelector('[data-review-reset]').addEventListener('click',()=>{style='all';select.value='all';apply();});
apply(false);
})();
